document.addEventListener('DOMContentLoaded', function () {
  const deliveryInfo = document.getElementById('variant-delivery-info');
  if (!deliveryInfo) return;

  function updateDelivery(variantId) {
    if (!variantId || !window.variantLagerorte) return;
    const lagerort = window.variantLagerorte[String(variantId)];
    if (lagerort === 'hersteller') {
      deliveryInfo.innerHTML = '<p class="delivery-message delivery-message--slow">Lieferzeit: 10–15 Werktage (Bestellung beim Hersteller)</p>';
    } else {
      deliveryInfo.innerHTML = '<p class="delivery-message delivery-message--fast">Lieferzeit: 3–5 Werktage</p>';
    }
  }

  // Dawn Custom Event
  document.addEventListener('variant:changed', function (e) {
    if (e.detail?.variant?.id) updateDelivery(e.detail.variant.id);
  });

  // Fallback: MutationObserver auf das hidden input
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    new MutationObserver(() => updateDelivery(variantInput.value))
      .observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }
});
